import React, { useContext, useEffect, useState } from "react";
import ReactBellIcon from "react-bell-icon";
import { Badge, Button, Col, Row } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { Store } from "../Store";
import {
  getLocalTimeFormatted,
  getTableDescriptionBreefTablet,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";

export default function TableButtonSmall(props) {
  const {
    cartItems,
    cart,
    keyy,
    isSelected,
    tableNum,
    tableMinWitdh,
    setTableTemp,
    ctxDispatch,
    isMobile,
  } = props;

  const [buttonTableExhangeEnabled, setButtonTableExhangeEnabled] =
    useState(false);
  const [isAlerting, setIsAlerting] = useState(false);
  const [alertMinuteCount, setAlertMinuteCount] = useState();

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const { state } = useContext(Store);

  const { tableTypes = [], users = [] } = state;

  useEffect(() => {
    if (cart.alertOn) {
      if (cartItems.length > 0) {
        const lastItemTime = new Date(
          cartItems[cartItems.length - 1].createdAt
        );
        const now = new Date();
        const timeDiffMinutes = (now - lastItemTime) / 60000;

        if (
          timeDiffMinutes > (cart.alertTimePeriod || 30) ||
          alertMinuteCount > (cart.alertTimePeriod || 30)
        ) {
          const alertInterval = setInterval(() => {
            setIsAlerting((prev) => !prev);
          }, 1000);
          return () => clearInterval(alertInterval);
        } else {
          setIsAlerting(false);
        }
      }
    } else {
      setIsAlerting(false);
    }
  }, [cartItems, alertMinuteCount, cart]);

  useEffect(() => {
    if (cart.alertOn ?? true) {
      if (cartItems.length > 0) {
        const alertTimeInterval = setInterval(() => {
          const timeDiff = Math.floor(
            Math.abs(
              new Date() - new Date(cartItems[cartItems.length - 1].createdAt)
            ) /
              (1000 * 60)
          );

          setAlertMinuteCount(timeDiff);
        }, 1000);
        return () => clearInterval(alertTimeInterval);
      }
    }
  }, [cartItems, cart]);

  return (
    <Button
      key={keyy}
      size={"sm"}
      className={
        (cartItems.length > 0 ? "text-start " : "") +
        (isSelected ? "border border-warning " : "")
      }
      style={
        isTabletOrMobile
          ? {
              aspectRatio: "1/1",
              minWidth: tableMinWitdh,
              position: "relative",
              transition: "background-color 0.5s ease",
            }
          : {
              minWidth: tableMinWitdh,
              aspectRatio: "1/1",
              margin: "0.3rem",
              marginTop: "0.3rem",
              marginBottom: "0.3rem",
              position: "relative",
              paddingTop: "0px",
              paddingBottom: "0px",
              transition: "background-color 0.5s ease",
            }
      }
      variant={
        isSelected && cartItems.length > 0 && isAlerting
          ? "danger"
          : isSelected
          ? "primary"
          : cartItems.length > 0
          ? isAlerting
            ? "danger"
            : "success"
          : "secondary"
      }
      onClick={() => {
        if (buttonTableExhangeEnabled) {
          return;
        }
        setTableTemp(tableNum);
        ctxDispatch({ type: "CLOSE_HISTORIC_MOD" });

        ctxDispatch({
          type: "SELECT_TABLE",
          payload: tableNum,
        });
      }}
    >
      {cartItems.length > 0 ? (
        <table className="table table-sm  mb-0 pt-0">
          <tbody>
            <tr>
              <td
                colSpan={2}
                className={"text-bold  text-warning p-0"}
                style={{ fontFamily: "monospace" }}
              >
                <span className="text-dark">{tableNum}</span>
                &nbsp;
                {cart &&
                  cart.description &&
                  getTableDescriptionBreefTablet(cart.description)}
              </td>
            </tr>

            {cartItems.length > 0 && (
              <tr className="small-font">
                <td className={"text-bold p-0"}>
                  {cart.alertOn ?? true ? (
                    <span>
                      {alertMinuteCount > 0 ? alertMinuteCount + " dk" : "yeni"}
                    </span>
                  ) : (
                    <span>
                      {getLocalTimeFormatted(
                        cartItems[0].createdAt || cartItems[0].initedAt
                      )}
                    </span>
                  )}
                </td>
              </tr>
            )}
            <tr className="small-font">
              <td className={"text-bold p-0"}>
                {turkishCurrencyFormatterNoPrecision(
                  cartItems
                    .filter((x) => !x.isGift && !x.isPartialPaid)
                    .reduce(
                      (a, c) =>
                        a +
                        c.quantity *
                          (c.feature ? c.feature.price + c.price : c.price) +
                        (c.answers
                          ?.flatMap((a) => a.answers)
                          .filter((a) => a && !a.product)
                          .reduce((a, c) => a + c.cost, 0) || 0),
                      0
                    )
                )}
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <>
          <Row>
            <Col>
              {cartItems.description ? (
                <Badge pill bg="danger">
                  {getTableDescriptionBreefTablet(cartItems.description)}
                </Badge>
              ) : (
                "Masa"
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Badge pill bg="dark">
                {tableNum}
              </Badge>
            </Col>
          </Row>
        </>
      )}

      {!isMobile &&
        cartItems.filter(
          (item) =>
            !item.delivered && (item.tableCode || item.clientCode) && item.alert
        ).length > 0 && (
          <div
            className="border border-danger rounded-circle bg-white"
            style={{
              position: "absolute",
              top: -4,
              left: -4,
              width: "22px",
              height: "22px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReactBellIcon
              active={false}
              animate={true}
              color="#dc3545"
              width={17}
              height={17}
            />
          </div>
        )}

      {cart.tableType &&
        tableTypes &&
        tableTypes
          .filter((tt) => tt.status)
          .find((u) => u._id === cart.tableType) && (
          <img
            src={tableTypes.find((u) => u._id === cart.tableType)?.image}
            alt={tableTypes.find((u) => u._id === cart.tableType)?.name}
            className="me-3"
            style={{
              width: "18px",
              height: "18px",
              borderRadius: "5px",
              position: "absolute",
              bottom: "0px",
              right: "-15px",
              opacity: "0.6",
            }}
          />
        )}
      {cart.cartItems.length > 0 && cart.onBusinessUser && users && (
        <div
          className="ms-3 text-warning"
          style={{
            position: "absolute",
            top: "-3px",
            left: "-10px",
            fontSize: "11px",
            fontFamily: "monospace",
          }}
        >
          {"•" +
            users
              .find((u) => u._id === cart.onBusinessUser)
              ?.name.substring(0, 7)}
        </div>
      )}
    </Button>
  );
}
